import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  GuardResult,
  MaybeAsync, Router,
  RouterStateSnapshot,
} from '@angular/router';
import {AuthService} from "../services/auth.service";

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(private $router: Router, private $auth: AuthService) {}
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): MaybeAsync<GuardResult> {
    return this.canActivate(childRoute, state);
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): MaybeAsync<GuardResult> {
    const replaceRegex = /returnURL=(.*)/gm;
    if (this.$auth.isAuth()) {
      return true;
    } else {
      if(state.root.queryParamMap.has('token')) {
        this.$auth.setToken('without_success', state.root.queryParamMap.get('token')!);
        return true;
      }
      this.$auth.logOut()
      this.$router.navigate(['/login'], {
        queryParams: {
          returnURL: state.url.replace(replaceRegex, ''),
        },
      }).then();
      return false;
    }
  }
}
@Injectable({
  providedIn: 'root',
})
export class IsLoggedInGuard implements CanActivate {
  constructor(private $auth: AuthService, private $router: Router) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
  ): Promise<boolean> {
    return !this.$auth.isAuth() || (await this.$router.navigate(['..'], {queryParams: route.queryParams}));
  }
}
